import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import {store, key} from './store'
import './style/main.css';
import './style/icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import VueAxios from "vue-axios";
import axios from "axios";

createApp(App).use(store, key).use(router).use(VueAxios, axios).component('icon', FontAwesomeIcon).mount('#app')
